import { render, staticRenderFns } from "./balance_rewards.vue?vue&type=template&id=43845aef&"
import script from "./balance_rewards.vue?vue&type=script&lang=js&"
export * from "./balance_rewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports